'use strict';

function checkURLRules(urlPath, displayRules) {
  return displayRules.reduce((defaultValue, rule) => {
    if (rule.type === 'OnUrlsContaining') {
      return urlPath.includes(rule.value);
    }

    if (rule.type === 'OnUrlsMatching') {
      return urlPath === rule.value;
    }

    return defaultValue;
  }, true);
}

function isValidURL(urlPath, displayRules) {
  return displayRules.reduce((defaultValue, rule) => {
    if (rule.type === 'OnUrlsNotMatching' && urlPath === rule.value) {
      return false;
    }

    return defaultValue;
  }, true);
}

function doesRuleApply(urlPath, displayRules) {
  if (!isValidURL(urlPath, displayRules)) {
    return false;
  }

  return checkURLRules(urlPath, displayRules);
}

function areParamsValid({ urlPath, displayRulesSettingsTypeId, displayRules }) {
  if (
    !urlPath ||
    !displayRulesSettingsTypeId ||
    !displayRules ||
    !displayRules.length ||
    displayRulesSettingsTypeId === 'ShowOnAllPages'
  ) {
    return false;
  }

  return true;
}

function displayOnPage({ advert, urlPath }) {
  if (!advert) {
    return false;
  }

  const { displayRulesSettingsTypeId, displayRules } = advert;

  if (!areParamsValid({ urlPath, displayRulesSettingsTypeId, displayRules })) {
    return true;
  }

  if (doesRuleApply(urlPath, displayRules)) {
    return displayRulesSettingsTypeId === 'ShowOnSelectedPages';
  }

  return displayRulesSettingsTypeId !== 'ShowOnSelectedPages';
}

module.exports = { displayOnPage };
